import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PlanPricingService {
  baseUrl: string = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getPlans(): Observable<any> {
    return this.http.get(`${this.baseUrl}/subscription/plans`);
  }

  createOrder(
    amount: number,
    planId: string,
    transactionType: string = 'credit_topup',
  ): Observable<any> {
    const payload = {
      amount: amount,
      plan_id: planId,
      transaction_type: transactionType,
    };
    return this.http.post(`${this.baseUrl}/subscription/create-order`, payload);
  }

  verifyPayment(
    razorpayOrderId: string,
    razorpayPaymentId: string,
    razorpaySignature: string,
  ): Observable<any> {
    const payload = {
      razorpay_order_id: razorpayOrderId,
      razorpay_payment_id: razorpayPaymentId,
      razorpay_signature: razorpaySignature,
    };
    return this.http.post(
      `${this.baseUrl}/subscription/verify-payment`,
      payload,
    );
  }

  getRazorpayConfig(): Observable<any> {
    return this.http.get(`${this.baseUrl}/subscription/razorpay-config`);
  }

  testPayment(razorpayOrderId: string): Observable<any> {
    const payload = {
      razorpay_order_id: razorpayOrderId,
    };
    return this.http.post(`${this.baseUrl}/subscription/test-payment`, payload);
  }

  getPaymentHistory(page: number = 1, limit: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    return this.http.get(`${this.baseUrl}/subscription/payment-history`, {
      params,
    });
  }
}
